__turbopack_context__.v({
  "viewMoreBtn": "SingleUseLicense-module-scss-module__f5szVG__viewMoreBtn",
});
